import { toast } from "react-toastify";
import { trackEvent } from "./analytics";

export async function shareShow(show) {
    if (!show) {
        return;
    }

    const slug = show.slug;
    if (!slug) {
        toast.error("Share link unavailable.");
        return;
    }

    const url = `${window.location.origin}/show/${slug}`;
    const shareData = {
        title: show.title,
        text: `Check out ${show.title} on PremiereLens`,
        url,
    };

    try {
        if (navigator.share) {
            await navigator.share(shareData);
            trackEvent("show_share", { method: "native", slug });
            return;
        }

        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(url);
            trackEvent("show_share", { method: "clipboard", slug });
            toast.success("Link copied to clipboard.");
            return;
        }

        window.prompt("Copy this link:", url);
        trackEvent("show_share", { method: "prompt", slug });
    } catch (error) {
        if (error?.name === "AbortError") {
            return;
        }
        console.error("Share failed:", error);
        toast.error("Unable to share the link.");
    }
}
